import {
  Capacitor,
  CapacitorHttp,
} from "@capacitor/core";

import {
  decorateDriverApiUrl,
} from "../services/appVersionTransport.js";

const DRIVER_ORIGIN =
  "https://driver.cargo-platform.online";

function isNativeRuntime() {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

function normalizeData(value) {
  if (
    value &&
    typeof value === "object"
  ) {
    return value;
  }

  if (
    typeof value !== "string"
  ) {
    return {};
  }

  try {
    return JSON.parse(value);
  } catch {
    return {};
  }
}

export async function reisorProDriverRequest(
  apiPath,
  {
    method = "GET",
    body,
    token = "",
    signal,
  } = {}
) {
  const path =
    String(apiPath || "").startsWith("/api/")
      ? String(apiPath || "")
      : `/api/${String(apiPath || "").replace(/^\/+/, "")}`;

  const headers = {
    Accept: "application/json",
  };

  if (body !== undefined) {
    headers["Content-Type"] =
      "application/json";
  }

  if (token) {
    headers.Authorization =
      `Bearer ${token}`;
  }

  if (isNativeRuntime()) {
    const nativeResponse =
      await CapacitorHttp.request({
        url: decorateDriverApiUrl(
          `${DRIVER_ORIGIN}${path}`
        ),
        method,
        headers,

        ...(
          body === undefined
            ? {}
            : { data: body }
        ),
      });

    const status =
      Number(
        nativeResponse?.status ||
        0
      );

    return {
      response: {
        ok:
          status >= 200 &&
          status < 300,

        status,
      },

      data:
        normalizeData(
          nativeResponse?.data
        ),
    };
  }

  const response =
    await fetch(
      path,
      {
        method,
        headers,

        credentials:
          "include",

        cache:
          "no-store",

        signal,

        body:
          body === undefined
            ? undefined
            : JSON.stringify(body),
      }
    );

  const data =
    await response
      .json()
      .catch(() => ({}));

  return {
    response,
    data,
  };
}

export function reisorProMarketRequest(
  path,
  options = {}
) {
  return reisorProDriverRequest(
    `/api/market-board${String(path || "")}`,
    options
  );
}
